import script from "./AppButton.vue?vue&type=script&lang=ts"
export * from "./AppButton.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__